import React from 'react';
import { cn } from '@skin-seoul/design-system';

type ProductCardContentProps = {
  children: React.ReactNode;
  bottomSlot?: React.ReactNode;
  className?: string;
};

export const HorizontalProductCardContent = ({ children, bottomSlot, className }: ProductCardContentProps) => {
  return (
    <div className={cn('flex flex-col justify-between w-full h-full pr-2 pl-4 pt-3 pb-2 min-w-0 rounded-r-[8px]', className)}>
      <div className="flex flex-col items-start gap-2 justify-center w-full">
        <>{children}</>
      </div>
      <>{bottomSlot}</>
    </div>
  );
};
